import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { onMounted, computed } from 'vue';
import { usePreferencesStore } from '@/store/preferences';
import { useExpensesStore } from '@/store/expenses';
import { useModuleLayoutFetcher } from '@/composables/useModuleLayoutFetcher';
import { HEADERS, DEFAULT_HEADER_ORDER } from '@/components/modules/expenses/expenses.config';

import Table from '@/components/views/TableView.vue';
import Filter from '@/components/drawer/Filters.vue';
import ViewsContainer from '@/components/views/ViewsContainer.vue';

const moduleName = 'Expenses';

export default /*@__PURE__*/_defineComponent({
  __name: 'Expenses',
  setup(__props) {

const preferencesStore = usePreferencesStore();
const expensesStore = useExpensesStore();

const {
  create,
  update,
  remove,
  exportCsv
} = useModuleLayoutFetcher(
  moduleName,
  (params) => expensesStore.fetchExpenses(params),
  {
    create: expensesStore.createExpense,
    update: (data) => expensesStore.updateExpense(data.id, data),
    remove: expensesStore.deleteExpense,
    exportCsv: () => Promise.resolve()
  }
);

onMounted(() => {
  preferencesStore.currentModule = moduleName;
  preferencesStore.setAllModuleHeaders(moduleName, HEADERS);
  preferencesStore.setDefaultModuleHeaders(
    moduleName,
    DEFAULT_HEADER_ORDER
      .map(value => HEADERS.find(header => header.value === value))
      .filter(Boolean) as typeof HEADERS
  );
});

const data = computed(() => expensesStore.expenses);

return (_ctx: any,_cache: any) => {
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      (_openBlock(), _createBlock(ViewsContainer, {
        moduleName: moduleName,
        listViewComponent: Table,
        filterComponent: Filter,
        data: data.value,
        config: '@/components/modules/expenses/expenses.config',
        onCreate: _unref(create),
        onUpdate: _unref(update),
        onDelete: _unref(remove),
        exportCsv: _unref(exportCsv),
        show_toolbar: true,
        show_pagination: true,
        title: {singular:'Gasto', plural:'Gastos'},
        key: moduleName
      }, null, 8, ["data", "onCreate", "onUpdate", "onDelete", "exportCsv"]))
    ]),
    _: 1
  }))
}
}

})